
import BlokkliComponent_frame_index from '../../components/Paragraph/Frame/index.vue'
import BlokkliComponent_view_index from '../../components/Paragraph/View/index.vue'
import BlokkliComponent_webform_index from '../../components/Paragraph/Webform/index.vue'

const rare: Record<string, any> = {
  block_frame: BlokkliComponent_frame_index,
  block_view: BlokkliComponent_view_index,
  block_webform: BlokkliComponent_webform_index
}
export default rare